export function applyTheme(theme) {

  document.documentElement.classList.remove('dark', 'money-green');

  if (theme === 'dark') {
    // standard dark mode
    document.documentElement.classList.add('dark');
  } else if (theme === 'money-green') {

    document.documentElement.classList.add('dark', 'money-green');
  }

  localStorage.setItem('theme', theme);
}

export function initTheme() {
  const theme = localStorage.getItem('theme') || 'light';
  applyTheme(theme);
  return theme;
}
